"use client";

import Image from "next/image";
import fireIcon from "@/assets/svgs/fireIcon.svg";
import brands from "./brands.json";
import "./SoldInfo.css";

export default function SoldInfoSolid({ brand }) {
  // JSON-Lookup
  const count = brands[brand];
  const shouldRender = count && count >= 100; // ≥ 100 Verkäufe?

  if (!shouldRender) return null;

  return (
    <div className="Sold-wrapper-solid">
      <div className="Sold-top">
        <Image src={fireIcon} className="Sold-fire-icon" alt="Feuer-Icon" />
        <p className="Sold-headline">Dein {brand} ist gefragt!</p>
      </div>
      <p className="Sold-text">
        Wir haben {count} <strong>{brand}-Fahrzeuge</strong> im letzten Monat verkauft.
      </p>
    </div>
  );
}
